export const DEFAULT_ERROR_MESSAGE = "We are experiencing technical issues. Please contact support."
export const CONVERGE_JS_URL = 'https://api.demo.convergepay.com/hosted-payments/Checkout.js'
export const CARD_ERROR_MESSAGE = 'Your payment declined due to insufficient funds or invalid card details. Please try again.'
